/**
 * Angular dependencies
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Komodo dependencies
 */
import {
  AccordionsModule,
  AlertsModule,
  BadgesModule,
  ButtonModule,
  CheckboxModule,
  ChipsModule,
  DropdownsModule,
  FiltersModule,
  InputFieldsModule,
  LoadingIndicatorsModule,
  ModalsModule,
  PaginationModule,
  PopoverModule,
  TabsModule,
  ToggleModule,
  TooltipModule
} from "gds-atom-components";


@NgModule({
  declarations: [],
  exports: [
    CommonModule,
    AccordionsModule,
    AlertsModule,
    BadgesModule,
    ButtonModule,
    CheckboxModule,
    ChipsModule,
    DropdownsModule,
    FiltersModule,
    InputFieldsModule,
    LoadingIndicatorsModule,
    ModalsModule,
    PaginationModule,
    PopoverModule,
    TabsModule,
    ToggleModule,
    TooltipModule
  ]
})
export class KomodoModule { }
